<template>
  <el-dialog
    :class="['custom-dialog', typeClass]"
    :append-to-body="appendToBody"
    :close-on-click-modal="clickOnModal"
    :visible.sync="dialogVisi"
    :width="width"
    @closed="$emit('closed')">
    <p slot="title" class="slot-title">
      <slot name="title">{{title}}</slot>
    </p>
    <slot name="content"></slot>
    <div class="dialog-btns" v-if="showFooter">
      <slot name="footer">
        <el-button 
          :type="cancelType || 'info'" 
          size="small" 
          @click="$emit('cancel')" 
          :loading="cancelLoading"
          v-show="!hideCancel">
          {{cancelText}}
        </el-button>
        <el-button 
          :type="confirmType || 'primary'" 
          size="small" 
          @click="$emit('confirm')" 
          :loading="confirmLoading">
          {{confirmText}}
        </el-button>
      </slot>
    </div>
  </el-dialog>
</template>

<script>
export default {
  computed: {
    dialogVisi: {
      get(){
        return this.visi
      },
      set(val){
        this.$emit('update:visi', val)
      }
    },
    typeClass(){
      let typeClass = ['primary', 'success', 'info', 'danger'];
      let index = typeClass.indexOf(this.type);
      return index != -1
      ? typeClass[index]
      : null;
    }
  },
  props: {
    visi: {
      type: Boolean,
      required: false,
      default: false
    },
    width: {
      type: String,
      required: false,
      default: '800px'
    },
    confirmText: {
      type: String,
      required: false,
      default: '确定'
    },
    cancelText: {
      type: String,
      required: false,
      default: '取消'
    },
    title: {
      type: String,
      required: false,
      default: '标题'
    },
    confirmLoading: Boolean,
    cancelLoading: Boolean,
    showFooter: {
      type: Boolean,
      default: true
    },
    hideCancel: Boolean,
    type: String,
    confirmType: String,
    cancelType: String,
    clickOnModal: Boolean,
    appendToBody: Boolean
  },
}
</script>

<style lang="scss">
.custom-dialog{
  .el-dialog{
    border-radius: 3px;
    .el-dialog__header{
      padding: 0;
      background-color: #169BD5;
      border-radius: 3px 3px 0 0;
      .slot-title{
        margin: 0;
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        color: #FFF;
        padding: 0 15px;
      }
      .el-dialog__headerbtn{
        top: 16px;

        .el-icon-close{
          color: #fff;
          font-weight: bold;
          transition: transform .3s;
        }

        &:hover{
          .el-icon-close{
            transform: scale(1.1);
          }
        }
      }
    }
    .el-dialog__body{
      padding: 0;
      .el-form{
        padding: 20px 15px;
        .el-select,
        .el-date-editor{
          width: 100%;
        }
      }
      .dialog-btns{
        border-top: 1px solid #E4E4E4;
        text-align: center;
        padding: 15px 0;
      }
    }
  }
  @mixin dialog_header($color){
    .el-dialog__header{
      background-color: $color;
    }
  }
  &.primary{
    @include dialog_header($text-primary);
  }
  &.success{
    @include dialog_header($text-success);
  }
  &.info{
    @include dialog_header($text-info);
  }
  &.warning{
    @include dialog_header($text-warning);
  }
  &.danger{
    @include dialog_header($text-danger);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomDialog.vue